module.exports = __webpack_public_path__ + "static/media/Poppins-Bold-latinext.96b6d546.woff2";